import { useQuery } from '@tanstack/react-query';
import { listLocations } from 'packages/tackle-api/src/co-sell-msft/listLocations';

export const useListLocations = ({
  searchQuery,
  enabled,
}: {
  searchQuery: string;
  enabled: boolean;
}) => {
  const searchQueryLower = searchQuery?.toLowerCase() || '';

  const getQuery = useQuery({
    queryKey: ['list-locations', searchQueryLower],
    queryFn: () => listLocations({ searchQuery: searchQueryLower }),
    staleTime: Infinity,
    enabled: !!enabled,
  });

  return getQuery;
};

export default useListLocations;
